import { useState } from 'react'
import { refreshAccessToken } from '../../../../utilities/extensions'
import { account } from '../../../../classes/Account'
import { apiURL } from '../../../../utilities/URLs'
import { useNavigate, useSearchParams } from 'react-router-dom'

export default function ConfirmCompleteModal({ applicationId, setShowConfirmCompleteModal }) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type') ?? ''
  const quarter = searchParams.get('quarter') ?? ''
  const [submittingDocuments, setSubmittingDocuments] = useState(false)

  const handleCompleteDocumentUpload = async () => {
    setSubmittingDocuments(true)

    const completeApplicationResponse = await fetch(`${apiURL}/api/applications/${applicationId}/documents/complete/`, {
      method: 'POST',
      headers: {
        'Authorization': account.accessToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        note: '',
        type,
        quarter
      })
    })
    const completeApplicationData = await completeApplicationResponse.json()
    if (completeApplicationData.response.error) {
      if (completeApplicationData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleCompleteDocumentUpload() : navigate('/', { state: { expired: true } })
      } else
        console.error(completeApplicationData.response.error)
    } else {
      setSubmittingDocuments(true)
      setTimeout(() => {
        setSubmittingDocuments(false)
        navigate(`/applications/${applicationId}/dashboard`)
      }, 2000)
    }
  }

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50'>
      <div className='bg-white rounded-lg shadow-lg max-w-md w-full p-6'>
        <h2 className='text-lg font-semibold mb-4'>Confirm Upload Completion</h2>
        <p className='text-sm text-gray-700 mb-6'>Are you sure you have uploaded all of the required documents?</p>
        <div className='flex justify-end gap-3'>
          <button disabled={submittingDocuments} onClick={() => setShowConfirmCompleteModal(false)} className={`px-4 py-2 text-sm rounded bg-gray-200 text-gray-800 hover:bg-gray-300 ${submittingDocuments ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
            Cancel
          </button>
          <button disabled={submittingDocuments} onClick={handleCompleteDocumentUpload} className={`px-4 py-2 text-sm rounded bg-ertc-primary text-white hover:bg-ertc-primary-dark ${submittingDocuments ? 'bg-gray-400 cursor-pointer' : 'bg-ertc-primary cursor-pointer'}`}>
            Yes, I'm Done
          </button>
        </div>
        <p className='text-gray-400 italic text-sm mt-4'>NOTE: Please know that as you upload documents, they are automatically saving. Please only click the button above once you have <span className='font-bold'>FINISHED</span> uploading all documents.</p>
        {submittingDocuments && (
          <div className='flex flex-row items-center justify-center gap-2 mt-5'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] border-gray-200 dark:border-slate-700 border-t-ertc-primary dark:border-t-ertc-primary h-8 w-8 animate-spin'></div>
            <p className='text-md text-center'>Submitting Documents...</p>
          </div>
        )}
      </div>
    </div>
  )
}